module.exports = __webpack_public_path__ + "img/questionnaire-page-hd-bg.b661407d.png";